import { formatTicker } from '@toggle/toggle';
import { useEffect, useState } from 'react';

import { postEntities } from '~/api/entities/entity-service';
import { ScreeningEntities } from '~/stores/use-chat/assistant-response.type';

type RowData = {
  key: string;
  ticker: string;
  [snake: string]: string;
  logo_url: string;
  tag: string;
};

export const useScreeningData = (entities: ScreeningEntities[]) => {
  const [loading, setLoading] = useState(true);
  const [rowData, setRowData] = useState<RowData[]>([]);
  const [columns, setColumns] = useState<string[]>(['ticker']);

  const mapWithEntityWithDetails = async (e: ScreeningEntities) => {
    const entities = await postEntities({
      filter: 2,
      args: [e.entity],
    });

    if (entities.error) {
      return undefined;
    }

    return {
      ...entities.data[0],
      snakes: Object.entries(e.snakes).reduce((a, c) => {
        return { ...a, [c[0]]: c[1].last_value_formatted };
      }, {} as Record<string, string>),
    };
  };

  useEffect(() => {
    const resolveEntities = async () => {
      const response = await Promise.all(
        entities.map(entity => mapWithEntityWithDetails(entity))
      );

      response.forEach(entity => {
        if (entity) {
          setRowData(state => [
            ...state,
            {
              key: `screeningMessage-${entity.default_snake}`,
              ticker: formatTicker(entity),
              logo_url: entity.logo_urls.dark_png,
              tag: entity.tag,
              ...entity.snakes,
            },
          ]);
          setColumns(state => [...state, ...Object.keys(entity.snakes)]);
        }
      });
      setLoading(false);
    };

    resolveEntities();
  }, [entities]);

  return { loading, rowData, columns };
};
